import { useEffect } from 'react'
import log from '../logging'
import { pylonIdentify } from './pylonIdentify'
import useUser from './useUser'

// Keep this in sync with the widget URL app id in client/index.html.
const PYLON_APP_ID = 'fb9680e5-eef5-4748-8e28-a23c26cc5934'

interface PylonWindow {
  pylon?: {
    chat_settings?: {
      app_id?: string
      email?: string
      name?: string
      email_hash?: string
    }
  }
}

export const usePylonChatSettings = (): void => {
  const [user] = useUser()

  useEffect(() => {
    let cancelled = false

    const initPylonIdentity = async () => {
      const globalWithPylon = globalThis as typeof globalThis & PylonWindow
      globalWithPylon.pylon ??= {}
      const clearChatSettings = () => {
        if (!globalWithPylon.pylon?.chat_settings) return
        delete globalWithPylon.pylon.chat_settings.app_id
        delete globalWithPylon.pylon.chat_settings.email
        delete globalWithPylon.pylon.chat_settings.name
        delete globalWithPylon.pylon.chat_settings.email_hash
      }

      try {
        // Only allow chat for verified identities.
        if (!user?.email) {
          clearChatSettings()
          return
        }

        if (cancelled) return
        const { email, emailHash } = await pylonIdentify()
        if (cancelled) return
        globalWithPylon.pylon.chat_settings ??= {}
        globalWithPylon.pylon.chat_settings.app_id = PYLON_APP_ID
        globalWithPylon.pylon.chat_settings.email = email
        globalWithPylon.pylon.chat_settings.name =
          [user.firstName, user.lastName].filter(Boolean).join(' ').trim() || email

        globalWithPylon.pylon.chat_settings.email_hash = emailHash
      } catch (err) {
        if (cancelled) return

        clearChatSettings()

        const message = err instanceof Error ? err.message : 'Failed to verify chat identity.'
        log.error(message, err)
      }
    }

    void initPylonIdentity()

    return () => {
      cancelled = true
    }
  }, [user?.email, user?.firstName, user?.lastName])
}
